import { render } from "./PanelProductImages.vue?vue&type=template&id=2da3624f"
import script from "./PanelProductImages.vue?vue&type=script&lang=js"
export * from "./PanelProductImages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__